import { Choice } from '../../design'
import { SETTINGS_COPY } from './copy'

const REPLY_CLAIM_MODES = ['required', 'optional'] as const
type ReplyClaimMode = (typeof REPLY_CLAIM_MODES)[number]

const modeOf = (requiresClaim: boolean): ReplyClaimMode => (requiresClaim ? 'required' : 'optional')

export const ReplyClaimField = ({
  requiresClaim,
  onChange,
}: {
  requiresClaim: boolean
  onChange: (requiresClaim: boolean) => void
}) => (
  <fieldset className="settings-modes">
    <legend className="field-label">{SETTINGS_COPY.replyClaim}</legend>
    {REPLY_CLAIM_MODES.map((mode) => (
      <Choice
        key={mode}
        name="settings-reply-claim"
        value={mode}
        checked={modeOf(requiresClaim) === mode}
        onChange={(value) => onChange(value === 'required')}
        label={SETTINGS_COPY.replyClaimModes[mode]}
        description={SETTINGS_COPY.replyClaimHints[mode]}
      />
    ))}
  </fieldset>
)
